<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="团队名称">
              <a-input v-model="filterForm.name" placeholder="团队名称" class="form-model-item" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="团队分类">
              <a-select v-model="filterForm.category" @change="onSearch">
                <a-select-option :value="1"> 业务团队 </a-select-option>
                <a-select-option :value="2"> 支撑团队 </a-select-option>
                <a-select-option :value="3"> 虚拟团队 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="团队成员">
              <user-select v-model="filterForm.user_id" allow-clear show-search show-all placeholder="团队成员" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button type="primary" @click="getTeamList">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="reset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="团队列表" size="small" class="filter-data">
      <span slot="extra">
        <a-button v-has="{ code: 'system:team:add', project: 0 }" class="handle-menu" type="primary" icon="plus" @click="onAdd">添加</a-button>
      </span>
      <a-table :loading="loading" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a v-dis="{ code: 'system:team:edit', project: 0 }" @click="onEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-dis="{ code: 'system:team:delete', project: 0 }" @click="onDelete(record)">删除</a>
        </span>
        <span slot="logo" slot-scope="text, record">
          <a-avatar shape="square" icon="team" :src="record.logo" class="table-image" />
        </span>
        <span slot="members" slot-scope="text, record">
          <a-popover title="团队成员">
            <template slot="content">
              <span v-for="member in record.members" :key="member.id" class="member-info">
                <a-avatar :size="16" :src="member.avatar_url" class="table-image" style="margin: 0 2px" />
                <span>{{ member.nickname }}; </span>
              </span>
            </template>
            <span>{{ record.members.map(item => item.nickname).join('; ') }}</span>
          </a-popover>
        </span>
        <span slot="owner" slot-scope="text, record">{{ record.owner.nickname }}</span>
        <span slot="category" slot-scope="text, record">{{ teamCategory[record.category]?.label || '--' }}</span>
      </a-table>
    </a-card>
    <team-modal :is-show="modalVisible" :team-id="teamId" :team-data="teamData" @close="close" />
  </div>
</template>

<script>
import { teamCategory } from '@/utils/dictionary';
import { teamList, teamDelete } from '@/api/system/team';

import UserSelect from '@/components/User/UserSelect';
import TeamModal from '@/pages/system/components/TeamModal';

const columns = [
  {
    title: 'Logo',
    dataIndex: 'logo',
    key: 'logo',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'logo' }
  },
  {
    title: '团队名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '团队描述',
    key: 'description',
    dataIndex: 'description'
  },
  {
    title: '负责人',
    key: 'owner',
    dataIndex: 'owner',
    scopedSlots: { customRender: 'owner' }
  },
  {
    title: '团队成员',
    width: '30%',
    ellipsis: true,
    scopedSlots: { customRender: 'members' }
  },
  {
    title: '团队分类',
    dataIndex: 'category',
    ellipsis: true,
    scopedSlots: { customRender: 'category' }
  },
  {
    title: '创建时间',
    key: 'created_time',
    dataIndex: 'created_time',
    width: 180,
    align: 'center'
  },
  {
    title: '操作',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  components: { TeamModal, UserSelect },
  data() {
    return {
      teamCategory,
      loading: false,
      filterForm: {
        name: null,
        category: null,
        page_size: 10,
        page_number: 1
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      teamInfo: {},
      modalVisible: false,
      teamId: null,
      teamData: {},
      expand: false,
      tableData: [],
      columns
    };
  },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    }
  },
  mounted() {
    this.getTeamList();
  },
  methods: {
    // 点击添加
    onAdd() {
      this.teamId = null;
      this.modalVisible = true;
    },

    // 点击编辑
    onEdit(record) {
      this.teamId = record.id;
      this.teamData = record;
      this.modalVisible = true;
    },

    // 删除团队
    onDelete(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该团队吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          const { code, message } = await teamDelete({ id: record.id });
          if (code === 2000) {
            self.$message.success('删除成功');
            self.getTeamList();
          } else {
            self.$message.warning(message);
          }
        }
      });
    },
    toggle() {
      this.expand = !this.expand;
    },

    // 获取团队列表
    getTeamList() {
      this.loading = true;
      teamList(this.filterForm)
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    reset() {
      this.filterForm = {
        name: null,
        category: null,
        level: null,
        page_size: this.pagination.pageSize,
        page_number: 1
      };
      this.getTeamList();
    },

    onSearch() {
      this.filterForm.page_number = 1;
      this.getTeamList();
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getTeamList();
    },

    // 关闭弹窗
    close() {
      this.modalVisible = false;
      this.getTeamList();
    }
  }
};
</script>

<style lang="less">
.customer-filter {
  margin-bottom: 16px;
}

.handle-menu {
  margin: 0 5px;
}
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
.member-info {
  margin-left: 4px;
}
</style>
